import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { formatters } from 'common';
import isNumber from 'lodash/isNumber';
import { TRANSFER_DIRECTIONS } from 'services/search';
import DetailsPanel from '../DetailsPanel';
import DefListColumn from '../DefListColumn';
import styles from './styles.css';
import messages from './messages';

export const formatDollars = (pennies) => (
  isNumber(pennies)
    ? formatters.formatDollars(pennies)
    : pennies
);

const AmountAvailablePanel = ({
  startDayCashAvailable,
  pendingDebitInterest,
  pendingDebitDividends,
  totalDisbursements,
  totalDeposits,
  total,
  direction,
  allowFullyPaidUnsettledFunds,
  fullyPaidUnsettledFundsAmount,
  amountRecentDepositThreshold,
}) => {
  const isDeposit = direction === TRANSFER_DIRECTIONS.transferDirectionDeposit;

  return (
    <DetailsPanel title={<FormattedMessage {...messages.amountAvailableDetails} />} allowFullyPaidFunds={allowFullyPaidUnsettledFunds}>
      <div className={classNames(styles.panel, isDeposit ? 'text-muted' : null)}>
        {isDeposit &&
          <span className={styles.notApplicable}>
            <FormattedMessage {...messages.notApplicableForDeposits} />
          </span>
        }
        <DefListColumn
          className={classNames(styles.defList, styles.periodSeparator)}
          title={<FormattedMessage {...messages.startDayCashAvailable} />}
          data={formatDollars(startDayCashAvailable)}
          dataTestHandle="amountAvailablePanel__startDayCashAvailable"
        />
        <DefListColumn
          className={classNames(styles.defList, styles.periodSeparator)}
          title={<FormattedMessage {...messages.pendingDebitInterest} />}
          data={formatDollars(pendingDebitInterest)}
          dataTestHandle="amountAvailablePanel__pendingDebitInterest"
        />
        <DefListColumn
          className={classNames(styles.defList, styles.periodSeparator)}
          title={<FormattedMessage {...messages.pendingDebitDividends} />}
          data={formatDollars(pendingDebitDividends)}
          dataTestHandle="amountAvailablePanel__pendingDebitDividends"
        />
        <DefListColumn
          className={classNames(styles.defList, styles.periodSeparator)}
          title={<FormattedMessage {...messages.totalDisbursements} />}
          data={formatDollars(totalDisbursements)}
          dataTestHandle="amountAvailablePanel__totalDisbursements"
        />
        <DefListColumn
          className={classNames(styles.defList, styles.periodSeparator)}
          title={<FormattedMessage {...messages.totalDeposits} />}
          data={formatDollars(totalDeposits)}
          dataTestHandle="amountAvailablePanel__totalDeposits"
        />
        {amountRecentDepositThreshold > 0 &&
          <DefListColumn
            className={classNames(styles.defList, styles.periodSeparator)}
            title={<FormattedMessage {...messages.amountRecentDepositThreshold} />}
            data={formatDollars(amountRecentDepositThreshold)}
            dataTestHandle="amountAvailablePanel__amountRecentDepositThreshold"
          />
        }
        <DefListColumn
          className={classNames(styles.defList, styles.periodSeparator)}
          title={<FormattedMessage {...messages.fullyPaidUnsettledFunds} />}
          data={formatDollars(fullyPaidUnsettledFundsAmount)}
          dataTestHandle="amountAvailablePanel__fullyPaidUnsettledFundsAmount"
        />
        <DefListColumn
          className={styles.totalDefList}
          title={<FormattedMessage {...messages.amountAvailable} />}
          data={formatDollars(total)}
          dataTestHandle="amountAvailablePanel__amountAvailable"
        />
      </div>
    </DetailsPanel>
  );
};

AmountAvailablePanel.propTypes = {
  startDayCashAvailable: PropTypes.number.isRequired,
  pendingDebitInterest: PropTypes.number.isRequired,
  pendingDebitDividends: PropTypes.number.isRequired,
  totalDisbursements: PropTypes.number.isRequired,
  totalDeposits: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  direction: PropTypes.string.isRequired,
  fullyPaidUnsettledFundsAmount: PropTypes.number,
  allowFullyPaidUnsettledFunds: PropTypes.bool,
  amountRecentDepositThreshold: PropTypes.number,
};

AmountAvailablePanel.defaultProps = {
  fullyPaidUnsettledFundsAmount: 0,
  allowFullyPaidUnsettledFunds: false,
  amountRecentDepositThreshold: 0,
};

export default AmountAvailablePanel;



// WEBPACK FOOTER //
// ./src/components/AmountAvailablePanel/index.js